// SheetDB Service - Simple Google Sheets API
interface FormData {
  clientName: string;
  pickupAddress: string;
  email: string;
  serviceType: string;
  phone?: string;
  notes?: string;
}

class SheetDBService {
  private apiUrl: string;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  async submitFormData(formData: FormData): Promise<{ success: boolean; message: string }> {
    try {
      const orderData = {
        timestamp: new Date().toISOString(),
        clientName: formData.clientName,
        pickupAddress: formData.pickupAddress,
        email: formData.email,
        serviceType: formData.serviceType,
        price: this.getServicePrice(formData.serviceType),
        phone: formData.phone || '',
        notes: formData.notes || '',
        status: 'pending'
      };

      console.log('Submitting to SheetDB:', orderData);

      // Create Basic Auth header
      const credentials = btoa('ljdf0u3d:eionoinjdlqqple2g3j4');
      
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Basic ${credentials}`
        },
        body: JSON.stringify(orderData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('SheetDB response:', result);

      return {
        success: true,
        message: 'Pickup submitted successfully!'
      };

    } catch (error) {
      console.error('Error submitting to SheetDB:', error);
      return {
        success: false,
        message: 'Failed to submit order. Please try again.'
      };
    }
  }

  private getServicePrice(serviceType: string): string {
    switch (serviceType) {
      case 'stumps':
        return '$1060';
      case 'logs':
      case 'brush':
        return '$660';
      default:
        return '$0';
    }
  }
}

// Export configured instance
export const sheetdbService = new SheetDBService(
  'https://sheetdb.io/api/v1/3ax3p9gxqpkeo'
);

export default SheetDBService; 